// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26y61","right":"styles_right__2pOFR"};